import React from "react";
import styles from "./FunnelInsightCard.module.css";

const renderInlineMarkdown = (text = "") => {
  const value = String(text || "");
  if (!value.includes("*")) return value;

  const parts = [];
  let lastIndex = 0;
  const regex = /\*\*([^*]+)\*\*|\*([^*]+)\*/g;
  let match;

  while ((match = regex.exec(value))) {
    if (match.index > lastIndex) {
      parts.push(value.slice(lastIndex, match.index));
    }
    if (match[1]) {
      parts.push(
        <strong key={`b-${match.index}`}>{match[1]}</strong>
      );
    } else if (match[2]) {
      parts.push(<em key={`i-${match.index}`}>{match[2]}</em>);
    }
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < value.length) {
    parts.push(value.slice(lastIndex));
  }

  return parts.length ? parts : value;
};

const FunnelTable = ({ table }) => {
  if (!table || (!table.headers && (!table.rows || !table.rows.length))) return null;
  const columnCount = table?.headers?.length || table?.rows?.[0]?.length || 0;
  return (
    <div className={styles.tableWrap} data-cols={columnCount || undefined}>
      {table.headers ? (
        <div className={styles.tableHeader}>
          {table.headers.map((cell, idx) => (
            <span key={`h-${idx}`} className={styles.tableHeaderCell}>
              {renderInlineMarkdown(cell)}
            </span>
          ))}
        </div>
      ) : null}
      <div className={styles.tableBody}>
        {table.rows.map((row, rIdx) => (
          <div key={`r-${rIdx}`} className={styles.tableRow}>
            {row.map((cell, cIdx) => (
              <span key={`c-${rIdx}-${cIdx}`} className={styles.tableCell}>
                {renderInlineMarkdown(cell)}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FunnelTable;
